import { useHistory } from 'react-router-dom';
import { Segment, VerticalSpacer } from './../core/core';
import useCalendly from '../openCalendly';
import CTAButton from '../components/CTAButton';
import cx from 'classnames';
import styles from './MarketingGallery.module.scss';
import utilityStyles from '../SCSS/common/utilityStyles.module.scss';
import segmentStyles from '../SCSS/Segment.module.scss';

type Props = {
  contentAsNoun: string;
  screenshotImageUrl: string;
};

const MarketingGallery = (props: Props) => {
  const { contentAsNoun, screenshotImageUrl } = props;

  const history = useHistory();

  const openCalendly = useCalendly();

  return (
    <>
      <div className={`${styles.ClassroomDashboard} ${utilityStyles.clearfix}`}>
        <VerticalSpacer ems={2} />
        <Segment className={utilityStyles.line}>
          <div className={segmentStyles.moduleTitle}>{contentAsNoun} Example</div>
        </Segment>
        <Segment className={utilityStyles.line}>
          <div className={styles.marketingCopy}>
            <p>This is a Peekapak PRO feature.</p>

            <p>
              For Peekapak PRO users, students have access to myPeekaville, our interactive learning game. As students
              create {contentAsNoun}, teachers can see their student&apos;s work here.
            </p>
            <div className={styles.ctaBtnContainer}>
              <CTAButton secondary onClick={() => openCalendly()}>
                schedule consultation
              </CTAButton>
              <CTAButton onClick={() => history.push('/features')}>upgrade now</CTAButton>
            </div>
          </div>
          <img
            alt='Screenshot'
            className={cx(styles.marketingImg, utilityStyles.marketingScreenshot)}
            src={screenshotImageUrl}
          />
        </Segment>
      </div>
    </>
  );
};

export default MarketingGallery;
